import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { uiActions } from '../store';
import { snackbarType } from '../components/SnackBarAlert';

export const useSnackbar = () => {
  const dispatch = useDispatch();

  const showSuccessSnackbar = useCallback(
    (message, duration = 5000) => {
      dispatch(
        uiActions.setSnackbar({
          message: message,
          type: snackbarType.SUCCESS,
          duration,
        }),
      );
    },
    [dispatch],
  );

  const showErrorSnackbar = useCallback(
    (message, duration = 5000) => {
      dispatch(
        uiActions.setSnackbar({
          message: message,
          type: snackbarType.ERROR,
          duration,
        }),
      );
    },
    [dispatch],
  );

  const showInfoSnackbar = useCallback(
    (message, duration = 5000) => {
      dispatch(
        uiActions.setSnackbar({
          message: message,
          type: snackbarType.INFO,
          duration,
        }),
      );
    },
    [dispatch],
  );

  const showWarningSnackbar = useCallback(
    (message, duration = 5000) => {
      dispatch(
        uiActions.setSnackbar({
          message: message,
          type: snackbarType.WARNING,
          duration,
        }),
      );
    },
    [dispatch],
  );

  const closeSnackbar = useCallback(() => {
    dispatch(
      uiActions.setSnackbar({ message: null, type: snackbarType.ERROR }),
    );
  }, [dispatch]);

  return {
    showSuccessSnackbar,
    showErrorSnackbar,
    showInfoSnackbar,
    showWarningSnackbar,
    closeSnackbar,
  };
};
